import React from "react";
import clsx from "clsx";
import { SvgIcon, SvgIconType } from "@/svg";
import { CheckIcon } from "@/components/CheckIcon";

type CheckboxOptionProps = {
  label: string;
  icon: SvgIconType;
  isChecked: boolean;
  onToggle: () => void;
};

export function CheckboxOption({ label, icon, isChecked, onToggle }: CheckboxOptionProps) {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div
      className="flex items-center justify-between p-2 cursor-pointer text-feintGray"
      onClick={onToggle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="flex items-center gap-2">
        <SvgIcon icon={icon} />
        {label}
      </div>
      <CheckIcon
        visible={isChecked}
        className={clsx(isHovered && !isChecked && "text-dark opacity-100")}
      />
    </div>
  );
}
